const L = ['0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011']
const G = ['0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111']
const R = L.map((code) => code.replace(/[01]/g, (b) => (b === '0' ? '1' : '0')))
const PARITY = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL']

function checkDigit(digits12) {
  let sum = 0
  for (let i = 0; i < 12; i++) sum += Number(digits12[i]) * (i % 2 === 0 ? 1 : 3)
  return (10 - (sum % 10)) % 10
}

// Retorna os 13 dígitos do EAN-13 a partir do número informado, ou null se não for possível.
// 12 dígitos: calcula o dígito verificador. 13 dígitos: exige verificador válido.
export function toEan13(value) {
  const raw = String(value === undefined || value === null ? '' : value).trim()
  if (!/^[\d\s-]+$/.test(raw)) return null
  const digits = raw.replace(/\D/g, '')
  if (digits.length === 12) return digits + checkDigit(digits)
  if (digits.length === 13 && Number(digits[12]) === checkDigit(digits.slice(0, 12))) return digits
  return null
}

// Sequência de 95 módulos ('1' = barra, '0' = espaço) de um EAN-13 de 13 dígitos.
export function ean13Modules(digits13) {
  const parity = PARITY[Number(digits13[0])]
  let modules = '101'
  for (let i = 0; i < 6; i++) {
    const digit = Number(digits13[i + 1])
    modules += parity[i] === 'L' ? L[digit] : G[digit]
  }
  modules += '01010'
  for (let i = 7; i < 13; i++) modules += R[Number(digits13[i])]
  return modules + '101'
}
